// AUTO BXGY for NMN+
(function () {
    'use strict';

    // Configuration
    const CONFIG = {
        productHandle: 'nmn',
        productId: 7771127513157,
        triggerQuantity: 1,
        freeItemVariantId: 43599706390597
    };

    let isProcessing = false;
    let userActionInProgress = false;
    let lastKnownCounts = null;
    let checkTimeout = null;

    // Count NMN+ items in cart
    function countIndigoItems() {
        return fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            let subscriptionCount = 0;
            let onetimeCount = 0;
            let freeItemCount = 0;

            cart.items.forEach(item => {
                if (item.product_id == CONFIG.productId) {
                    if (item.properties && item.properties._free_item === 'true') {
                        freeItemCount += item.quantity;
                    } else if (item.selling_plan_allocation) {
                        subscriptionCount += item.quantity;
                    } else {
                        onetimeCount += item.quantity;
                    }
                }
            });

            return {
                subscription: subscriptionCount,
                onetime: onetimeCount,
                freeItems: freeItemCount,
                totalPaid: subscriptionCount + onetimeCount,
                total: subscriptionCount + onetimeCount + freeItemCount,
                cart: cart
            };
        });
    }

    // Debounced check function to prevent rapid re-execution
    function debouncedCheck() {
        if (checkTimeout) {
            clearTimeout(checkTimeout);
        }
        
        checkTimeout = setTimeout(() => {
            if (!isProcessing && !userActionInProgress) {
                checkAndAddFreeItem();
            }
        }, 2000); // 2 second delay
    }

    // Check and add free item logic
    function checkAndAddFreeItem() {
        if (isProcessing || userActionInProgress) {
            console.log('BXGY: Skipping check - processing or user action in progress');
            return;
        }
        
        countIndigoItems().then(counts => {
            const neededFreeItems = Math.floor(counts.totalPaid / 1);
            const currentFreeItems = counts.freeItems;

            console.log('BXGY Check:', {
                totalPaid: counts.totalPaid,
                currentFree: currentFreeItems,
                neededFree: neededFreeItems,
                userAction: userActionInProgress
            });

            // Only proceed if we actually need to make changes
            if (counts.totalPaid >= 1 && currentFreeItems < neededFreeItems) {
                const itemsToAdd = neededFreeItems - currentFreeItems;
                console.log('BXGY: Need to add', itemsToAdd, 'free items');
                addFreeItemToCart(itemsToAdd);
            } else if (currentFreeItems > neededFreeItems && counts.totalPaid < 1) {
                // Only remove free items if user has less than 1 paid items
                const itemsToRemove = currentFreeItems;
                console.log('BXGY: Need to remove', itemsToRemove, 'free items (insufficient paid items)');
                removeFreeItemFromCart(itemsToRemove);
            }

            lastKnownCounts = counts;
        });
    }

    // Add free item to cart
    function addFreeItemToCart(quantity) {
        if (isProcessing) return;
        isProcessing = true;
        console.log('BXGY: Adding', quantity, 'free items');

        const formData = {
            'items': [{
                'id': CONFIG.freeItemVariantId,
                'quantity': quantity,
                'properties': {
                    '_free_item': 'true',
                    '_bxgy_offer': 'Buy 1 Get 1 Free'
                }
            }]
        };

        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData)
        })
        .then(response => response.json())
        .then(data => {
            console.log('BXGY: Free item added successfully');
            showNotification(`${quantity} Free NMN+ added to your cart! 🎁`);
            
            // Force complete cart refresh
            setTimeout(() => {
                refreshCartDrawer();
                isProcessing = false;
            }, 1000);
        })
        .catch(error => {
            console.error('BXGY: Error adding free item:', error);
            isProcessing = false;
        });
    }

    // Remove excess free items
    function removeFreeItemFromCart(quantity) {
        if (isProcessing) return;
        isProcessing = true;
        console.log('BXGY: Removing', quantity, 'free items');

        fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            const freeItems = cart.items.filter(item => 
                item.product_id == CONFIG.productId && 
                item.properties && 
                item.properties._free_item === 'true'
            );

            if (freeItems.length > 0) {
                const updates = {};
                let itemsToRemove = quantity;

                freeItems.forEach(item => {
                    if (itemsToRemove > 0) {
                        const removeQty = Math.min(item.quantity, itemsToRemove);
                        updates[item.key] = item.quantity - removeQty;
                        itemsToRemove -= removeQty;
                    }
                });

                fetch('/cart/update.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ updates: updates })
                })
                .then(() => {
                    console.log('BXGY: Free items removed successfully');
                    showNotification(`${quantity} excess free item(s) removed`, 'info');
                    setTimeout(() => {
                        refreshCartDrawer();
                        isProcessing = false;
                    }, 1000);
                });
            } else {
                isProcessing = false;
            }
        });
    }

    // Comprehensive cart drawer refresh
    function refreshCartDrawer() {
        console.log('BXGY: Refreshing cart drawer');
        
        // Method 1: Fetch fresh cart data and update drawer
        fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            // Try multiple cart refresh methods
            const cartDrawer = document.querySelector('cart-drawer');
            
            if (cartDrawer) {
                // Method A: Direct content refresh
                if (typeof cartDrawer.renderContents === 'function') {
                    cartDrawer.renderContents(cart);
                }
                
                // Method B: Trigger cart drawer events
                cartDrawer.dispatchEvent(new CustomEvent('cart:updated', { 
                    detail: { cart: cart },
                    bubbles: true 
                }));
                
                // Method C: Force re-render by fetching cart HTML
                fetch('/cart?view=drawer')
                .then(response => response.text())
                .then(html => {
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(html, 'text/html');
                    const newContent = doc.querySelector('cart-drawer');
                    if (newContent && cartDrawer) {
                        cartDrawer.innerHTML = newContent.innerHTML;
                    }
                })
                .catch(e => console.log('BXGY: Cart HTML refresh failed'));
            }
            
            // Method 2: Global cart refresh functions
            if (typeof window.cartRefresh === 'function') {
                window.cartRefresh();
            }
            if (typeof window.updateCart === 'function') {
                window.updateCart();
            }
            
            // Method 3: Update cart count
            const cartCounts = document.querySelectorAll('.cart-count, [data-cart-count], .cart-count-bubble');
            cartCounts.forEach(el => {
                el.textContent = cart.item_count;
            });
            
            // Method 4: Trigger global events
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
            document.dispatchEvent(new CustomEvent('cart:refresh'));
        });
    }

    // Monitor product page
    function monitorProductPage() {
        const quantitySelector = document.querySelector('[name="quantity"]');
        const addToCartForm = document.querySelector('form[action*="/cart/add"]');

        if (quantitySelector && addToCartForm) {
            addToCartForm.addEventListener('submit', function(e) {
                const quantity = parseInt(quantitySelector.value) || 1;
                const sellingPlanInput = document.querySelector('[name="selling_plan"]');
                const isSubscription = sellingPlanInput && sellingPlanInput.value;

                console.log('BXGY Form submit:', { quantity, isSubscription });

                if (quantity >= 1) {
                    e.preventDefault();
                    addItemsWithFreeGift(quantity, isSubscription);
                }
            });
        }
    }

    // Add items with free gift
    function addItemsWithFreeGift(itemQuantity, isSubscription) {
        userActionInProgress = true;
        const freeQuantity = Math.floor(itemQuantity / 1);
        const variantId = document.querySelector('[name="id"]').value;
        const sellingPlan = document.querySelector('[name="selling_plan"]')?.value;

        console.log('BXGY Adding from product page:', { itemQuantity, freeQuantity, isSubscription });

        const mainItemData = {
            'items': [{
                'id': parseInt(variantId),
                'quantity': itemQuantity
            }]
        };

        if (isSubscription && sellingPlan) {
            mainItemData.items[0].selling_plan = parseInt(sellingPlan);
        }

        fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(mainItemData)
        })
        .then(response => response.json())
        .then(data => {
            console.log('BXGY: Main items added from product page');
            
            if (freeQuantity > 0) {
                return addFreeItemToCart(freeQuantity);
            } else {
                refreshCartDrawer();
            }
        })
        .then(() => {
            const purchaseType = isSubscription ? 'subscription' : 'one-time purchase';
            showNotification(`Added ${itemQuantity} ${purchaseType} + ${freeQuantity} free item(s)! 🎉`);
            
            setTimeout(() => {
                userActionInProgress = false;
                const cartDrawer = document.querySelector('cart-drawer');
                if (cartDrawer) {
                    if (typeof cartDrawer.open === 'function') {
                        cartDrawer.open();
                    } else {
                        cartDrawer.classList.add('active');
                    }
                } else {
                    window.location.href = '/cart';
                }
            }, 1500);
        })
        .catch(error => {
            console.error('BXGY: Error in addItemsWithFreeGift:', error);
            userActionInProgress = false;
        });
    }

    // Monitor user actions
    function monitorUserActions() {
        // Track ANY user interaction with cart
        document.addEventListener('click', function(e) {
            const target = e.target;
            
            // Check if user clicked any cart-related button
            if (target.matches(`
                .cart-remove, 
                [data-cart-remove], 
                .quantity__button, 
                [data-quantity-button],
                .cart-item__remove,
                [href*="cart/change"],
                button[name="minus"],
                button[name="plus"]
            `.replace(/\s+/g, ''))) {
                
                console.log('BXGY: User cart action detected, pausing auto-add');
                userActionInProgress = true;
                
                // Clear any pending checks
                if (checkTimeout) {
                    clearTimeout(checkTimeout);
                }
                
                // Resume checking after user action is complete
                setTimeout(() => {
                    console.log('BXGY: Resuming auto-add after user action');
                    userActionInProgress = false;
                    debouncedCheck();
                }, 3000); // 3 second pause
            }
        });

        // Monitor form submissions (quantity updates)
        document.addEventListener('submit', function(e) {
            if (e.target.matches('form[action="/cart"]')) {
                console.log('BXGY: Cart form submitted, pausing auto-add');
                userActionInProgress = true;
                
                setTimeout(() => {
                    userActionInProgress = false;
                    debouncedCheck();
                }, 3000);
            }
        });

        // Monitor input changes
        document.addEventListener('change', function(e) {
            if (e.target.matches('[name*="updates"], .quantity__input')) {
                console.log('BXGY: Quantity input changed, pausing auto-add');
                userActionInProgress = true;
                
                setTimeout(() => {
                    userActionInProgress = false;
                    debouncedCheck();
                }, 3000);
            }
        });
    }

    // Show notification
    function showNotification(message, type = 'success') {
        const existing = document.querySelectorAll('.bogo-notification');
        existing.forEach(el => el.remove());

        const notification = document.createElement('div');
        notification.className = `bogo-notification bogo-${type}`;
        notification.innerHTML = `
            <div class="notification-content">
                <span class="notification-message">${message}</span>
                <button class="notification-close">&times;</button>
            </div>
        `;

        document.body.appendChild(notification);

        setTimeout(() => {
            if (notification.parentNode) {
                notification.remove();
            }
        }, 5000);

        notification.querySelector('.notification-close').addEventListener('click', () => {
            notification.remove();
        });
    }

    // Add CSS for notifications
    function addNotificationStyles() {
        if (document.querySelector('#bogo-notification-styles')) return;

        const style = document.createElement('style');
        style.id = 'bogo-notification-styles';
        style.textContent = `
            .bogo-notification {
                position: fixed;
                top: 20px;
                right: 20px;
                background: #4caf50;
                color: white;
                padding: 15px 20px;
                border-radius: 8px;
                box-shadow: 0 4px 12px rgba(0,0,0,0.15);
                z-index: 10000;
                max-width: 350px;
                animation: slideIn 0.3s ease-out;
            }

            .bogo-notification.bogo-info {
                background: #2196f3;
            }

            @keyframes slideIn {
                from { transform: translateX(100%); opacity: 0; }
                to { transform: translateX(0); opacity: 1; }
            }

            .notification-content {
                display: flex;
                justify-content: space-between;
                align-items: center;
            }

            .notification-close {
                background: none;
                border: none;
                color: white;
                font-size: 18px;
                cursor: pointer;
                margin-left: 10px;
            }

            @media (max-width: 768px) {
                .bogo-notification {
                    top: 10px;
                    right: 10px;
                    left: 10px;
                    max-width: none;
                }
            }
        `;
        document.head.appendChild(style);
    }

    // Initialize monitoring
    function initCartMonitoring() {
        console.log('BXGY: Initializing...');
        
        addNotificationStyles();

        if (window.location.pathname.includes('/products/')) {
            monitorProductPage();
        }

        // Monitor user actions
        monitorUserActions();

        // Initial check after page load (with delay)
        setTimeout(() => {
            if (!userActionInProgress) {
                checkAndAddFreeItem();
            }
        }, 3000);
        
        // Periodic check (much less frequent)
        setInterval(() => {
            if (!isProcessing && !userActionInProgress) {
                debouncedCheck();
            }
        }, 15000); // Check every 15 seconds
    }

    // Start when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initCartMonitoring);
    } else {
        initCartMonitoring();
    }

})();
